import { Loader2 } from "lucide-react";

export const Loader = ({ label = "Loading…" }) => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[#FFF7E6]" data-testid="app-loader">
    <Loader2 className="w-10 h-10 text-[#F97316] animate-spin" />
    <p className="text-lg text-[#111827]/70 font-medium">{label}</p>
  </div>
);

export const EmptyState = ({ icon: Icon, title, subtitle, action }) => (
  <div className="flex flex-col items-center justify-center text-center py-12 px-6" data-testid="empty-state">
    {Icon && <div className="w-16 h-16 rounded-2xl bg-[#C4B5FD]/25 flex items-center justify-center mb-4"><Icon className="w-8 h-8 text-[#111827]/60" /></div>}
    <h3 className="text-xl font-semibold text-[#111827]">{title}</h3>
    {subtitle && <p className="text-[#111827]/60 mt-2 max-w-sm">{subtitle}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);
